module.exports = __webpack_public_path__ + "static/media/Empanelment-three.39397a87.png";